module.exports = __webpack_public_path__ + "img/1578016595.3f0c709e.jpg";